"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _i18n = require("@active/react-utils/i18n");
var _eventHandler = require("@active/react-utils/eventHandler");
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _excluded = ["onClear", "onClick", "onKeyDown"];
var InputClearButton = function InputClearButton(_ref, ref) {
  var _rest$ariaLabel;
  var onClear = _ref.onClear,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useLocale = (0, _i18n.useLocale)(),
    i18n = _useLocale.i18n;
  var ariaLabel = (_rest$ariaLabel = rest['aria-label']) !== null && _rest$ariaLabel !== void 0 ? _rest$ariaLabel : i18n('react-ui.searchInput.ariaLabel.clear');
  var handleClick = _react["default"].useCallback(function (e) {
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
    onClear === null || onClear === void 0 ? void 0 : onClear();
  }, [onClear, onClick]);
  var handleKeyDownOnClear = (0, _eventHandler.useOnKeyboardConfirm)(onClear, [onClear]);
  var handleKeyDown = _react["default"].useCallback(function (e) {
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    handleKeyDownOnClear(e);
  }, [handleKeyDownOnClear, onKeyDown]);
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({
    alt: ariaLabel,
    "aria-label": ariaLabel,
    icon: "ic-cross-r",
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    ref: ref,
    type: "clear"
  }, rest));
};
var Forwarded = (0, _compose["default"])(_react["default"].memo, _react["default"].forwardRef)(InputClearButton);
var _default = exports["default"] = Forwarded;